import React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  REQUEST_LOANS,
  REQUEST_LOANS_FAILURE,
  REQUEST_LOANS_SUCCESS,
} from '../constants/ActionTypes';

import { fields, detailFields, entityMap } from '../constants/fields/EmployeeMasterObjectOnLoan';
import convert from '../utils/dateTools';

export function mapLoans(q) {
  return {
    fields,
    detailFields,
    entityMap,
    Entity: q.Entity,
    ObjectTypeName: {
      label: <FormattedMessage id="loan.type" />,
      value: q.ObjectTypeName,
      entity: 'ObjectType',
    },
    Amount: {
      label: <FormattedMessage id="loan.amount" />,
      value: q.Amount,
      entity: 'Amount',
    },
    Pieces: {
      label: <FormattedMessage id="loan.pieces" />,
      value: q.Pieces,
      entity: 'Pieces',
    },
    ObjectNumber: {
      label: <FormattedMessage id="loan.objectNumber" />,
      value: q.ObjectNumber,
      entity: 'ObjectNumber',
    },
    Begda: {
      label: <div><FormattedMessage id="loan.begda" /></div>,
      value: convert(q.Begda),
      entity: 'Begda',
    },
    Endda: {
      label: <div><FormattedMessage id="loan.endda" /></div>,
      value: convert(q.Endda),
      entity: 'Endda',
    },
  };
}

export default function loansReducer(state = {}, action) {
  switch (action.type) {
    case REQUEST_LOANS:
      return {
        ...state,
        loaded: false,
        isFetching: true,
        loansData: [],
      };

    case REQUEST_LOANS_FAILURE:
      return {
        ...state,
        loaded: true,
        isFetching: false,
        error: action.error,
        loansData: [],
      };

    case REQUEST_LOANS_SUCCESS:
      return {
        ...state,
        loaded: true,
        isFetching: false,
        lastUpdated: action.receivedAt,
        loansData: action.loansData.map(mapLoans),
      };

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/loansReducer.js